import { Mail, Phone, Globe, MessageCircle } from "lucide-react";

export default function Contact() {
    return (
        <section className="min-h-screen pt-40 pb-16 mesh-gradient" data-testid="contact-page">
            <div className="max-w-3xl mx-auto px-6">
                <div className="text-center mb-12">
                    <span className="inline-block px-4 py-2 rounded-full glass-light text-xs font-semibold text-brand-400 mb-4">GET IN TOUCH</span>
                    <h1 className="font-display font-bold text-4xl md:text-5xl mb-4">Contact Connexa</h1>
                    <p className="text-gray-400 max-w-xl mx-auto">
                        Questions, feedback, or need help with your account? We'd love to hear from you — usually reply within 24 hours.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-6">
                    <a href="mailto:Support@connexa.co.in" className="glass rounded-2xl p-6 card-hover text-center block" data-testid="contact-email">
                        <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-brand-500/20 flex items-center justify-center">
                            <Mail className="w-7 h-7 text-brand-400" />
                        </div>
                        <h3 className="font-semibold text-base mb-1">Email Us</h3>
                        <p className="text-gray-400 text-sm break-all">Support@connexa.co.in</p>
                    </a>

                    <a href="tel:+919136581868" className="glass rounded-2xl p-6 card-hover text-center block" data-testid="contact-phone">
                        <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-brand-500/20 flex items-center justify-center">
                            <Phone className="w-7 h-7 text-brand-400" />
                        </div>
                        <h3 className="font-semibold text-base mb-1">Call Us</h3>
                        <p className="text-gray-400 text-sm">+91 91365 81868</p>
                    </a>

                    <a
                        href="https://wa.me/919136581868?text=Hi%20Connexa%20Team%2C%20I%27d%20like%20to%20learn%20more."
                        target="_blank"
                        rel="noreferrer"
                        className="glass rounded-2xl p-6 card-hover text-center block border-whats-green/20"
                        data-testid="contact-whatsapp"
                    >
                        <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-whats-green/20 flex items-center justify-center">
                            <MessageCircle className="w-7 h-7 text-whats-green" />
                        </div>
                        <h3 className="font-semibold text-base mb-1">WhatsApp</h3>
                        <p className="text-gray-400 text-sm">Quick chat with our team</p>
                    </a>
                </div>

                <div className="glass rounded-2xl p-6 md:p-8 mt-8 flex items-center gap-4">
                    <div className="w-12 h-12 rounded-2xl bg-brand-500/20 flex items-center justify-center flex-shrink-0">
                        <Globe className="w-6 h-6 text-brand-400" />
                    </div>
                    <div>
                        <h3 className="font-semibold text-base mb-0.5">Website</h3>
                        <a href="https://www.connexa.in" target="_blank" rel="noreferrer" className="text-brand-400 hover:underline text-sm">
                            www.connexa.in
                        </a>
                    </div>
                </div>

                <p className="text-center text-xs text-gray-500 mt-10">
                    Business hours: Mon–Sat, 10 AM – 7 PM IST · We typically reply within 24 hours
                </p>
            </div>
        </section>
    );
}
